import * as React from 'react'
import { FastField } from 'formik'

import { MuiTextFieldFormik } from '@user/components/Formik'
import { SoldServiceAppDataNumber } from '@user/store/opportunity'

import { useGetCustomFieldProps } from '../hooks'

type Props = {
  disabled: boolean
  appData: SoldServiceAppDataNumber
}

export function NumberField(props: Props) {
  const { appData, disabled } = props

  const fieldProps = useGetCustomFieldProps(appData)

  return (
    <FastField
      {...fieldProps}
      component={MuiTextFieldFormik}
      disabled={disabled}
      type="number"
    />
  )
}
NumberField.displayName = 'NumberField'
